// extracted by mini-css-extract-plugin
export var button = "_bv-0";
export var icon = "_bv-1";